import { searchAtom } from "@/core/reatom/state/search";
import { useAtom } from "@reatom/npm-react";
import { useEffect, useState } from "react";
import { Joyride } from "react-joyride";
import { CustomTooltip } from "../CustomTooltip/CustomTooltip";
import { steps } from "./joyride-steps";

export const JoyrideTooltips = () => {
  const [run, setRun] = useState(false);
  const [search] = useAtom(searchAtom);

  useEffect(() => {
    if (search?.items.length) {
      const hasRunBefore = localStorage.getItem("tooltips");

      if (!hasRunBefore) {
        setRun(true);
        localStorage.setItem("tooltips", "true");
      }
    }
  }, [search]);

  const handleJoyrideCallback = (data: { action: unknown; type: unknown }) => {
    const { action, type } = data;

    if (type === "tooltip:close" || action === "close") {
      setRun(false);
    }
  };

  return (
    <Joyride
      callback={handleJoyrideCallback}
      steps={steps}
      run={run}
      continuous={true}
      disableScrolling={true}
      disableScrollParentFix={true}
      tooltipComponent={CustomTooltip}
      spotlightPadding={2}
      floaterProps={{
        styles: {
          arrow: {
            length: 8.78,
            spread: 19.73,
          },
        },
      }}
      styles={{
        options: {
          arrowColor: "var(--bg)",
        },
      }}
    />
  );
};
